// LoadingProducts.jsx

import React from "react";
import { useNavigate } from "react-router-dom";
const NoResults = ({ message }) => {
  const navigate = useNavigate();
  const handleContinue = () => {
    navigate("/products"); // or your desired route
  };

  return (
    <div
      style={{ minHeight: "40vh" }}
      className="mt-20 py-40 d-flex flex-column justify-content-center align-items-center"
    >
      <div className="text-center ">
        <p className="h5">{message}</p>
      </div>
      <div className="center mt-20">
        <button className="btn btn-outline-main" onClick={handleContinue}>
          Continue Shopping
        </button>
      </div>
    </div>
  );
};

export default NoResults;
